export default __webpack_public_path__ + "static/media/photo--sm--hockey.6de04ea4.jpg";